var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHealthActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.75 35H16.25C14.8699 34.9986 13.7514 33.8801 13.75 32.5V26.25H7.5C6.11986 26.2486 5.00138 25.1301 5 23.75V16.25C5.00138 14.8699 6.11986 13.7514 7.5 13.75H13.75V7.5C13.7514 6.11986 14.8699 5.00138 16.25 5H23.75C25.1301 5.00138 26.2486 6.11986 26.25 7.5V13.75H32.5C33.8801 13.7514 34.9986 14.8699 35 16.25V23.75C34.9979 25.1299 33.8799 26.2479 32.5 26.25H26.25V32.5C26.2479 33.8799 25.1299 34.9979 23.75 35ZM7.5 16.25V23.75H16.25V32.5H23.75V23.75H32.5V16.25H23.75V7.5H16.25V16.25H7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealthActive);
export default __webpack_public_path__ + "static/media/ic-health-active.a6dc5227.svg";
export { ForwardRef as ReactComponent };